import axios from 'axios';
import {
	Message
} from 'element-ui';
axios.interceptors.request.use(config => {
	return config;
}, err => {
	Message.error({
		message: '请求超时!'
	});
	// return Promise.resolve(err);
});

function clearCookie(){
	var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
	if (keys) {
		for (var i = keys.length; i--;) {
			document.cookie = keys[i] + '=0;path=/;expires=' + new Date(0).toUTCString();//清除当前域名下的,例如：m.xcc.cn
			document.cookie = keys[i] + '=0;path=/;domain=' + document.domain + ';expires=' + new Date(0).toUTCString();//清除当前域名下的，例如 .m.xcc.cn
			document.cookie = keys[i] + '=0;path=/;domain=xcc.cn;expires=' + new Date(0).toUTCString();//清除一级域名下的或指定的，例如 .xcc.cn
		}
	}
};

var getWindowUrl = function(){
	return window.location.href;
};

var getTimeString = function(){
	var timeString = new Date().getTime();
	return timeString;
};

axios.interceptors.response.use(data => {    // 请求失败校验
	if (data.status && data.status == 200 && data.data.status == 10086) {

		if (data.data.msg.indexOf('登录') >= 0) {
            localStorage.removeItem('userId');
            localStorage.removeItem('token');
            localStorage.removeItem('is_Vip');
            localStorage.setItem('Vip',2);
            localStorage.removeItem('is_corp');
            clearCookie();
            window.location.href = "/login";
		}
	}else if(data.status && data.status == 200 && data.status == 204){
		Message.error({
			message: '搜索词语模糊!'
		});
		return;
	}else if(data.status && data.status == 200 && data.status == 203){
        Message.error({
            message: data.data.msg
        });
		return;
	}else if(data.status && data.status == 200 && data.data.status == 401){
		localStorage.removeItem('userId');
		localStorage.removeItem('token');
		localStorage.removeItem('is_Vip');
		localStorage.setItem('Vip',2);
		localStorage.removeItem('is_corp');
		clearCookie();
        window.location.href = "/login";
	}else if (data.data.status != undefined) {
		if (data.data.status != 200 && data.data.status != 509) {
			if(data.data.status == 401){
				localStorage.removeItem('userId');
				localStorage.removeItem('token');
				localStorage.removeItem('is_Vip');
				localStorage.setItem('Vip',2);
				localStorage.removeItem('is_corp');
				clearCookie();
				window.location.href = "/login";
			}else{
				
				return data;
			}
		}else if(data.data.status == 509){
			Message.error({
				message: data.data.msg
			});
			return
		}
	}
	return data;
}, err => {
	if (err.response.status == 203) {
		localStorage.removeItem('userId');
		localStorage.removeItem('token');
		localStorage.removeItem('is_Vip');
		localStorage.setItem('Vip',2);
		localStorage.removeItem('is_corp');
		clearCookie();
		window.location.href = "/login";
	} else if (err.response.status == 401) {
		// localStorage.setItem("msg401",data.data.msg);
		localStorage.removeItem('userId');
		localStorage.removeItem('token');
		localStorage.removeItem('is_Vip');
		localStorage.setItem('Vip',2);
		localStorage.removeItem('is_corp');
		clearCookie();
		window.location.href = "/login";
	} else if (err.response.status == 504) {
		Message.error({
			message: '服务器被吃了⊙﹏⊙∥'
		});
	} else if (err.response.status == 403) {
		Message.error({
			message: '权限不足,请联系管理员!'
		});
	} else if (err.response.status == 404){
		Message.error({
			message: err.response.data.msg
		});
	} else if (err.response.status == 500){
		Message.error({
			message: err.response.data.msg
		});
	} else if (err.response.status == 10086){
		Message.error({
			message: err.response.data.msg
		});
	} else if (err.response.status == 509){
        Message.error({
            message: err.response.data.msg
        });
	} else if (err.response.status == 413){
		Message.error({
			message: '由于您的非法操作，IP被拉入黑名单，请联系管理员'
		});
	} else {
		if (err.response.data.msg) {
			Message.error({
				message: err.response.data.msg
			});
		} else {
			Message.error({
				message: '未知错误!'
			});
		}
	}
	return Promise.resolve(err);
});


let base = "https://ins.xinchacha.com/"; //正式环境
// let base = "http://192.168.0.218:8888/";  //文晓 

export const postRequest = (url, params) => {
	var userId = localStorage.getItem('userId');
	var token = localStorage.getItem('token');
	var headObj = {
		'token': token,
		'username':userId,
		'Content-Type': 'application/json;charset=UTF-8',
		'baseUrl':getWindowUrl(),
		'time':getTimeString()
	};
	var headObj1 = {
		'Content-Type': 'application/json;charset=UTF-8',
		'baseUrl':getWindowUrl(),
		'time':getTimeString()
	};
	return axios({
		method: 'post',
		url: `${base}${url}`,
		data: params,
		headers: userId != null? headObj:headObj1
	});
};

export const getDateRequest = (url, sanshu) => {
	var userId = localStorage.getItem('userId');
	var token = localStorage.getItem('token');
	var timeString = getTimeString();
	var headObj = {
		'token': token,
		'username':userId,
		'Content-Type': 'application/x-www-form-urlencoded',
		'time':timeString,
		'baseUrl':getWindowUrl()
	}
	var headObj1 = {
		'Content-Type': 'application/x-www-form-urlencoded',
		'time':timeString,
		'baseUrl':getWindowUrl()
	}
	return axios.get(base+url,{
		params:sanshu,
		headers: userId != null ? headObj:headObj1
	});
};

export const getRequest = (url, params) => {
	// ${base}
	var userId = localStorage.getItem('userId');
	var token = localStorage.getItem('token');
	var headObj=null;
	var headObj1=null;
	
    headObj = {
        'token': token,
        'username':userId,
        'Content-Type': 'application/x-www-form-urlencoded',
        'time':getTimeString()
    }
    headObj1 = {
        'Content-Type': 'application/x-www-form-urlencoded',
        'time':getTimeString()
    }
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params:params,
        headers: userId != null? headObj:headObj1
    });
};

export const postParamDun = (url, sanshu) => {
	var userId = localStorage.getItem('userId');
	var token = localStorage.getItem('token');
	var headObj = {
		'token': token,
		'username':userId,
		'Content-Type': 'application/x-www-form-urlencoded',
		'access-control-allow-origin':"*",
		'baseUrl':getWindowUrl(),
		'time':getTimeString()
	}
	var headObj1 = {
		'Content-Type': 'application/x-www-form-urlencoded',
		'access-control-allow-origin':"*",
		'baseUrl':getWindowUrl(),
		'time':getTimeString()
	}
	return axios({
		method: 'post',
		url: `${base}${url}`,
		data:sanshu,
		transformRequest: [function(data) {
			let ret = ''
			for (let it in data) {
				ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
			}
			return ret
		}],
		headers: userId != null ? headObj:headObj1
	});
};




// WEBPACK FOOTER //
// ./src/utils/api.js